// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"Header_headerWrapper__ldpTf","header":"Header_header__3rkz2","headerBlock":"Header_headerBlock__1d0B5","headerItem":"Header_headerItem__2CxOY"};